import React from "react";
import { AntdTable, ContainerDiv } from "./styles";
import { COLORS } from "../../../../../../../layout/theme";

export default function ProductsTable({ data, columns }) {
	return (
		<ContainerDiv containerBackground={COLORS.LightGrey}>
			<AntdTable
				showHeader={true}
				columns={columns}
				dataSource={data}
				pagination={false}
				scroll={{
					y: 960,
				}}
			/>
		</ContainerDiv>
	);
}
